module.exports = __webpack_public_path__ + "media/images/web/home/index/music-b6a23df4d065a301e160c5fba6ca02c4.webp";